import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import { FadeIn, FadeOut } from "./ModalFade";
import "./PopupMessage.css";
export const PopupMessage = (props = { Header: "", Body: "", useCloseButton: true, useRefreshButton: false, OnClose() {
    }, }) => {
    const [triggerFadeIn, setTriggerFadeIn] = useState(false);
    const reset = () => {
        window.location.reload();
    };
    const fadeBackIn = () => {
        setTriggerFadeIn(true);
        // animation duration delay
        setTimeout(() => {
            props.OnClose();
        }, 500);
    };
    return (_jsxs(_Fragment, { children: [!triggerFadeIn && (_jsxs("div", Object.assign({ id: "Popup_Container" }, { children: [_jsx("img", { src: "./Images/Misc/Popup_Background.svg", alt: "popup_background" }), _jsx("h1", Object.assign({ id: "Popup_Header" }, { children: props.Header })), _jsx("p", Object.assign({ id: "Popup_Body" }, { children: props.Body })), props.useRefreshButton && (_jsx("button", Object.assign({ id: "Popup_RefreshBtn", onClick: reset }, { children: "Refresh" }))), props.useCloseButton && (_jsx("button", Object.assign({ id: "Popup_CloseBtn", onClick: fadeBackIn }, { children: "Close Message" })))] }))), !triggerFadeIn && _jsx(FadeOut, { isFullFade: false }), triggerFadeIn && _jsx(FadeIn, { isFullFade: false })] }));
};
